export default {
  TREATMENT_PLANNING_LINK: 'TREATMENT_PLANNING_LINK',
  UPLOAD_SINGLE_VIDEO: 'UPLOAD_SINGLE_VIDEO',
  UPLOAD_MULTIPLE_VIDEOS: 'UPLOAD_MULTIPLE_VIDEOS',
  UPLOAD_PDF: 'UPLOAD_PDF',
  DO_NOT_UPLOAD: 'DO_NOT_UPLOAD',
}
